// Tracks in-flight update API requests by item ID → AbortController.
// Shared across update-item and remove-item mutations so that a remove
// can abort any in-flight update for the same item.
export var activeUpdateRequests = new Map();